// extracted by mini-css-extract-plugin
module.exports = {"buttonHover":"styles_buttonHover__xXfGj","buttonAnalise":"styles_buttonAnalise__2K9Af"};